import {Backdrop, Box, Card, CardActionArea, CardContent, Grid, Paper, Typography} from "@mui/material";
import * as React from "react";

const InfoCard = (props: any) => {
    const {
        type = 'primary',
        selectCard,
        selected,
        id,
        title,
        description,
        src,
        prefix = '',
        backgroundColor = 'background.paper',
        hoverBackgroundColor = 'action.selectedHover',
        variantTitle = 'h4',
        cardRadius = '4px',
        animated = false,
        style = {
            height: '100%',
            '&[data-active]': {
                backgroundColor: backgroundColor,
                '&:hover': {
                    backgroundColor: hoverBackgroundColor,
                },
            },
        },
        animatedStyle = {
            top: 0,
            left: 0,
            width: '200%',
            height: '200%',
            backgroundColor: hoverBackgroundColor,
            borderRadius: '0 0 100% 0',
            transform: 'scale(0)',
            transformOrigin: 'top left',
        }
    } = props;

    const layout = () => {
        if (type === 'primary') {
            return (
                <>
                    <Typography variant={variantTitle} component="div">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontWeight="bold">
                        {description}
                    </Typography>
                </>
            )
        } else {
            return (
                <>
                    <Typography variant={variantTitle} color="text.secondary" fontWeight="bold" mt={2}>
                        {title}
                    </Typography>
                    <Box display="flex" justifyContent="space-between" flexDirection="column">
                        <Typography variant="subtitle1" component="div" fontWeight="bold">
                            {prefix}&nbsp;
                        </Typography>
                        <Typography variant="h4" component="div">
                            {description}
                        </Typography>
                    </Box>
                </>
            )
        }
    }

    const selectCardStyle = () => {
        if (animated) {
            return (
                <CardActionArea
                    onClick={() => selectCard(id)}
                    data-active={selected === id ? '' : undefined}
                    sx={{
                        height: '100%',
                        position: 'relative',
                        backgroundColor: backgroundColor,
                        overflow: 'hidden',
                        '&:hover .overlay': {
                            transform: 'scale(1)',
                        },
                    }}
                >
                    <Box
                        className="overlay"
                        sx={{
                            ...animatedStyle,
                            content: '""',
                            position: 'absolute',
                            transition: 'transform 0.6s ease-out',
                            zIndex: 0,
                        }}
                    />
                    <CardContent sx={{
                        height: '100%',
                        position: 'relative',
                        zIndex: 1,
                        padding: '16px',
                        '&.MuiCardContent-root': {
                            paddingBottom: '16px',
                        }
                    }}>
                        <Grid container spacing={2} sx={{ height: '100%', minHeight: "-webkit-fill-available" }}>
                            <Grid size={6}
                                  display="flex"
                                  justifyContent="space-between"
                                  flexDirection="column"
                                  minHeight="-webkit-fill-available"
                            >
                                {layout()}
                            </Grid>
                            <Grid size={6} display="flex" justifyContent="flex-end">
                                <Box component={"img"} sx={{height: 60, width: 60}} alt="Logo NRE Control" src={src}/>
                            </Grid>
                        </Grid>
                    </CardContent>
                </CardActionArea>
            )
        }
        return (
            <CardActionArea
                onClick={() => selectCard(id)}
                data-active={selected === id ? '' : undefined}
                sx={style}
            >
                <CardContent sx={{
                    height: '100%',
                    position: 'relative',
                    zIndex: 1,
                    padding: '16px',
                    '&.MuiCardContent-root': {
                        paddingBottom: '16px',
                    }
                }}>
                    <Grid container spacing={2} sx={{ height: '100%', minHeight: "-webkit-fill-available" }}>
                        <Grid size={6}
                              display="flex"
                              justifyContent="space-between"
                              flexDirection="column"
                              minHeight="-webkit-fill-available"
                        >
                            {layout()}
                        </Grid>
                        <Grid size={6} display="flex" justifyContent="flex-end">
                            <Box component={"img"} sx={{height: 60, width: 60}} alt="Logo NRE Control" src={src}/>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        )

    }

    return selectCard ? (
        <Card sx={{width: "100%", borderRadius: cardRadius}}>
            {selectCardStyle()}
        </Card>
    ) : (
        <Card sx={{width: "100%", borderRadius: cardRadius}}>
            <CardContent sx={{
                height: '100%',
                padding: '16px',
                '&.MuiCardContent-root': {
                    paddingBottom: '16px',
                }
            }}>
                <Grid container spacing={2} sx={{ height: '100%', minHeight: "-webkit-fill-available" }}>
                    <Grid size={6}
                          display="flex"
                          justifyContent="space-between"
                          flexDirection="column"
                          minHeight="-webkit-fill-available"
                    >
                        {layout()}
                    </Grid>
                    <Grid size={6} display="flex" justifyContent="flex-end">
                        <Box component={"img"} sx={{height: 60, width: 60}} alt="Logo NRE Control" src={src}/>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default InfoCard;
